var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "team-list-wrapper mt-3" },
    [
      _c("b-table", {
        staticClass: "w-100",
        attrs: {
          "thead-class": "table-header",
          hover: "",
          items: _setup.userItems,
          fields: _setup.fields,
          responsive: "sm",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(name)",
            fn: function (data) {
              return [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "div",
                    { staticClass: "pr-3" },
                    [
                      _c(_setup.CUserAvatar, {
                        attrs: {
                          circle: "",
                          name: data.item.user.Name,
                          "picture-path": data.item.user.ProfilePicturePath,
                          size: 40,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "mb-1" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(data.item.user.Name) +
                          "\n                        "
                      ),
                      data.item.accessMode == _setup.AccessMode.RESTRICTED
                        ? _c(
                            "span",
                            { staticClass: "ml-2 px-2 badge2 badge-secondary" },
                            [_vm._v("Collaborator\n                        ")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex user-subtitle" }, [
                      _c("div", [_vm._v(_vm._s(data.item.user.Username))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "px-2" }, [_vm._v("|")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(data.item.user.Email))]),
                    ]),
                  ]),
                ]),
              ]
            },
          },
          {
            key: "cell(actions)",
            fn: function (data) {
              return [
                !_setup.user?.ImpersonatedFromChildUser
                  ? _c(
                      "div",
                      { staticClass: "row-actions" },
                      [
                        _c(_setup.CDropdown, {
                          staticClass: "options-button",
                          attrs: {
                            label: "",
                            tooltip: "Options",
                            items: _setup.getCDropdownActionsForItem(data.item),
                            variant: "empty",
                            icon: "fa-ellipsis",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "dropdown-menu-item",
                                fn: function ({ label, disabled }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center w-100",
                                        class: disabled
                                          ? "disabled-element"
                                          : undefined,
                                        attrs: { disabled: disabled },
                                      },
                                      [
                                        _c("span", { staticClass: "w-100" }, [
                                          _vm._v(_vm._s(label)),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }